module.exports = __webpack_public_path__ + "media/images/pic/anime/popcorn-7ff17d02879c333336879ec472c15a71.svg";